 <!--Full width header Start-->
<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>
<!--Full width header End-->
<!-- Main content Start -->
<div class="main-content">
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">Our Colleges</h1>
      <ul>
        <li><a class="active" href="/">Home</a></li>

        <li>Our Colleges</li>
      </ul>
    </div>
  </div>
  <div class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70 representative-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 rs-faq-part style1 orange-color">
          <div class=" main-part">
            <div class="title mb-40 md-mb-15">
              <h2 class="text-part">Our Colleges</h2>
            </div>
            <div class="faq-content">
              <div class="faq-side-layout">
                <div class="faq-side-questions nav flex-column" id="faq-tab" role="tablist" aria-orientation="vertical">
                  <a
                    *ngFor="let college of colleges; let index = index; trackBy: trackByCollegeId"
                    class="card-link"
                    [class.active]="index === 0"
                    [id]="college.tabId"
                    data-toggle="pill"
                    [href]="'#' + college.paneId"
                    role="tab"
                    [attr.aria-controls]="college.paneId"
                    [attr.aria-selected]="index === 0"
                    (click)="onTabSelect(college.id)">
                    {{ college.label }}
                  </a>
                </div>
                <div class="faq-side-answers tab-content" id="faq-tab-content">
                  <div
                    *ngFor="let college of colleges; let index = index; trackBy: trackByCollegeId"
                    class="tab-pane fade"
                    [class.show]="index === 0"
                    [class.active]="index === 0"
                    [id]="college.paneId"
                    role="tabpanel"
                    [attr.aria-labelledby]="college.tabId">
                    <div class="blog-table-wrap">
                      <div *ngIf="college.isLoading" class="alert alert-info mb-0" role="status">
                        Loading {{ college.label }} colleges data...
                      </div>

                      <div *ngIf="!college.isLoading && college.errorMessage" class="alert alert-warning mb-0" role="alert">
                        {{ college.errorMessage }}
                      </div>

                      <div *ngIf="!college.isLoading && !college.errorMessage && !college.rows.length" class="alert alert-secondary mb-0" role="status">
                        No colleges data available.
                      </div>

                      <div *ngIf="!college.isLoading && !college.errorMessage && college.rows.length" class="table-responsive">
                        <table class="sheet-table">
                          <thead>
                            <tr>
                              <th *ngFor="let column of college.columns; trackBy: trackByColumnIndex" scope="col">{{ column }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let row of college.rows; trackBy: trackByRowIndex">
                              <td *ngFor="let cell of row; let colIndex = index; trackBy: trackByColumnIndex">
                                <ng-container [ngSwitch]="getColumnKind(college, colIndex)">
                                  <ng-container *ngSwitchCase="'location'">
                                    <a
                                      *ngIf="getCellUrl('location', cell) as locationUrl; else locationFallback"
                                      [href]="locationUrl"
                                      class="sheet-link sheet-link-location"
                                      target="_blank"
                                      rel="noopener noreferrer">
                                      <i class="fa fa-map-marker" aria-hidden="true"></i>
                                      <span>{{ getLocationLabel(cell) }}</span>
                                    </a>
                                    <ng-template #locationFallback>{{ cell }}</ng-template>
                                  </ng-container>

                                  <ng-container *ngSwitchCase="'website'">
                                    <a
                                      *ngIf="getCellUrl('website', cell) as websiteUrl; else websiteFallback"
                                      [href]="websiteUrl"
                                      class="sheet-link"
                                      target="_blank"
                                      rel="noopener noreferrer">
                                      {{ cell }}
                                    </a>
                                    <ng-template #websiteFallback>{{ cell }}</ng-template>
                                  </ng-container>

                                  <ng-container *ngSwitchDefault>{{ cell }}</ng-container>
                                </ng-container>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
